import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import {
    DeleteCadastroDeDirecionamentoController,
    ListagemCadastroDeDirecionamentoController,
} from "../../../Controllers/AssistenciaTecnica/CadastroDeDirecionamento/CadastroDeDirecionamento";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { ICadastroDeDirecionamento } from "../../../Interfaces/AssistenciaTecnica/CadastroDeDirecionamento/CadastroDeDirecionamentoInterface";
import { formatMoneyReais } from "../../../Tools/FormatTools";
import CreateUpdateDirecionamento from "./CreateUpdateDirecionamento";

export default function CadastroDeDirecionamento() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        value: lstCadastroDirecionamento,
        loading: lstCadastroDirecionamentoLoading,
        execute: ListagemCadastroDeDirecionamento,
    } = useAsyncEffect(() => ListagemCadastroDeDirecionamentoController(), []);

    const {
        execute: DeleteCadastroDeDirecionamento,
        loading: DeleteCadastroDeDirecionamentoLoading,
    } = useAsyncCallback(DeleteCadastroDeDirecionamentoController);

    const columns: Array<ColumnDescription<ICadastroDeDirecionamento>> = [
        {
            dataField: "DS_ESTADO",
            text: "Estado",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "DS_RESIDENCIAL",
            text: "Residencial",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "DS_SUBASSUNTO",
            text: "Subassunto - Classificação",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "DATA",
            text: "Data",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
            align: "center",

            formatter: (c, row) => {
                return <span>{moment(row.DATA).format("DD/MM/YYYY")}</span>;
            },
        },
        {
            dataField: "VL_VALOR",
            text: "Valor",
            classes: "p-3 ws-nowrap",
            formatter: (c) => formatMoneyReais(c),
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "MES",
            text: "Mês",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "ANO",
            text: "Ano",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            align: "center",
            formatter: (c, row) => (
                <div className="Button-Tools">
                    <button
                        type="button"
                        className="btn btn-primary mr-2 "
                        onClick={() => {
                            setShow(true);
                            setModal({
                                headerComponent: "Editar Direcionamento",
                                IconHeader: faEdit,
                                Component: () => (
                                    <CreateUpdateDirecionamento
                                        row={row}
                                        setShow={setShow}
                                        ListagemCadastroDeDirecionamento={
                                            ListagemCadastroDeDirecionamento
                                        }
                                    />
                                ),
                                size: "lg",
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                    </button>

                    <button
                        type="button"
                        className="btn btn-danger mr-2"
                        disabled={DeleteCadastroDeDirecionamentoLoading}
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja apagar este direcionamento?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DeleteCadastroDeDirecionamento(row.ID).then(
                                        (response) => {
                                            ListagemCadastroDeDirecionamento();
                                        }
                                    );
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="lg" /> Excluir
                    </button>
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="d-flex justify-content-end my-2">
                <button
                    className="btn btn-success"
                    onClick={() => {
                        setShow(true);
                        setModal({
                            headerComponent: "Cadastrar Direcionamento",
                            IconHeader: faPlus,
                            Component: () => (
                                <CreateUpdateDirecionamento
                                    setShow={setShow}
                                    ListagemCadastroDeDirecionamento={
                                        ListagemCadastroDeDirecionamento
                                    }
                                />
                            ),
                            size: "lg",
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </button>
            </div>
            <div className="card card-body">
                <Table
                    columns={columns}
                    data={lstCadastroDirecionamento ?? []}
                    keyField="ID"
                    bordered={false}
                    loading={lstCadastroDirecionamentoLoading}
                    striped
                    noSearch
                    noDataIndication={() => (
                        <div className="text-center">
                            Nenhum dado encontrado
                        </div>
                    )}
                />
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
